import React from 'react';
import styled from 'styled-components'
import { useHistory } from "react-router-dom";
import { Element } from 'react-scroll'


import BigCard from "../reusable/BigCard"




const Home = (props) => {

  let history = useHistory();
  // useEffect(() => {
  //   const resizeListener = () => {
  //     if(window.innerWidth < 600){
  //       setUrl("../websiteMobile.jpg");
  //     } else {
  //       setUrl("../website.jpg");
  //     }
  //   };

  //   if(window.innerWidth < 600){
  //     setUrl("../websiteMobile.jpg");
  //   } else {
  //     setUrl("../website.jpg");
  //   }

  //   window.addEventListener('resize', resizeListener);

  //   return () => {
  //     window.removeEventListener('resize', resizeListener);
  //   }
  // }, [])


  return(
    <Wrapper>
      <Element name="platform">
        <BigCard 
          onClick={()=>history.push("/learn-more-about-minimaa")} 
          cta="Learn more" 
          text="Online Art Exhibition Space for Students and Universities" 
          imgUrl="../../sculpture1.png" 
          mobileImgUrl="../../mobileSculpture1.png" 
        />
      </Element>
      <Element name="community">
        <BigCard 
          onClick={()=>window.open("https://www.instagram.com/onlineartexhibitionspace")} 
          cta="Follow us on Instagram" 
          text="Our community has a certain je ne sais quoi about it." 
          imgUrl="../../sculpture2.png" 
        />
      </Element>
      <Element name="contact">
        <BigCard 
          onClick={()=>{window.location.href = "mailto:hello@minimaa.co"}} 
          cta="Get in touch" 
          text="Are you curious and would like to know more now?" 
          imgUrl="../../sculpture3.png" 
        />
      </Element>
    </Wrapper>
  )
}

export default Home



const Wrapper = styled.div(props => ({
  margin:"0px 100px",
  "@media (max-width: 980px)": {
    margin:"0px 50px",
  },
  "@media (max-width: 650px)": {
    margin:"0px 16px",
  }
}));

